import parseJsonContent from "../../../Utils/parseJsonContent";

export default function TermsAndConditionsModal({ isOpen, onClose, onAccept, terms, loading }) {
    if (!isOpen) return null;
    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: "block" }} aria-modal="true" role="dialog">
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    zIndex: 1000,
                }}
                onClick={onClose}
            >
                <div
                    className="modal-dialog modal-dialog-centered"
                    onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside content
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 font-family-poppins">Terms and Conditions</h1>
                            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: "70dvh", overflowY: "auto" }}>
                            {loading ? (
                                <div className="skeleton-loader" style={{ height: "100px", backgroundColor: "#e0e0e0", borderRadius: "5px" }}></div>
                            ) : (
                                <p>{terms?.[0]?.Content ? parseJsonContent(terms?.[0]?.Content) : ""}</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" style={{ marginTop: "10px", padding: "10px", backgroundColor: "#00008b", color: "#fff", border: "none", borderRadius: "5px" }} onClick={onAccept}>
                                Accept
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
